
export function checkSignUpResponse(
  serviceResponse,
  signUpFormSettings,
  phoneNumber
) {
  if (serviceResponse.responseCode) {
    const value = signUpFormSettings?.signUpResponseMessageDetails?.find(
      (x) => x.envisionAPIResponseText && x.responseCode === serviceResponse.responseCode
    );

    if (value) {
      let isError = true;
      const title = value.envisionAPIResponseText;
      let message = "";
      if (value.responseCode == 101) {
        isError = true;
        message = value.messageToBeShown;
        return { isError, title, message };
      }

      if (value.responseCode == 102) {
        if (phoneNumber) {
          message = value.messageToBeShown.replace(
            "&lt;helpline phone number&gt;",
            phoneNumber
          );
          return { isError, title, message };
        }
        message = value.messageToBeShown;
        return { isError, title, message };
      }

      message = value.messageToBeShown;
      return { isError, title, message };
    }

    const isError = true;
    const title = "We had trouble signing you in";
    const message = serviceResponse.responseMessage.concat(
      " (Error code ",
      serviceResponse.responseCode,
      ")"
    );
    return { isError, title, message };
  }

  return null;
}
